<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue'
  import LogoIcon from '@static/logo.svg'

  const images = Object.values(
    import.meta.glob('@/static/login/*.jpg', {
      eager: true,
      query: '?url',
      import: 'default'
    })
  )
  const currentImageIndex = ref(0)
  const bgImage = ref(images[currentImageIndex.value])

  defineOgImageComponent('SocialPreview')
  useSeoMeta({
    title: `${process.env.VITE_APP_TITLE}`,
    ogTitle: `${process.env.VITE_APP_TITLE}`,
    description: `${process.env.VITE_APP_DESCRIPTION}`,
    ogDescription: `${process.env.VITE_APP_DESCRIPTION}`,
    ogUrl: `${process.env.VITE_SITE_URL}`,
    ogType: 'website'
  })

  // Função para mudar a imagem de fundo
  const changeBackgroundImage = () => {
    currentImageIndex.value = (currentImageIndex.value + 1) % images.length
    bgImage.value = images[currentImageIndex.value]
  }

  let intervalId: ReturnType<typeof setInterval>

  onMounted(() => {
    intervalId = setInterval(changeBackgroundImage, 10000)
  })

  onUnmounted(() => {
    clearInterval(intervalId)
  })
</script>

<template>
  <div>
    <section class="container-fluid">
      <div class="row vh-100">
        <div
          class="d-none d-md-block col-md-7 banner"
          :style="{ backgroundImage: `url(${bgImage})` }"
        />
        <div class="col-12 col-md-5 d-flex align-items-center">
          <div class="w-100">
            <div class="d-flex align-items-center mx-auto">
              <div class="col-11 col-md-8 mx-auto">
                <div class="row px-1">
                  <LogoIcon
                    class="img-responsive h-auto mx-auto w-75 mb-3"
                    filled
                  />
                  <slot />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
  .banner {
    .background-responsive {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    transition: background-image 0.5s ease;
  }
  /* End Custom placeholder */
</style>
